import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_Widget.scss';

const Widget = props => {
  const { className, title, headerContent, children, ...rest } = props;
  const widgetClassName = classNames('Widget', className);

  return (
    <div {...rest} className={widgetClassName}>
      <div className="Widget__header">
        <div className="Widget__header-title">{title}</div>
        {headerContent && <div className="Widget__header-content">{headerContent}</div>}
      </div>

      <div className="Widget__body">{children}</div>
    </div>
  );
};

Widget.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  headerContent: PropTypes.node,
  className: PropTypes.string
};

export default Widget;
